import { render, staticRenderFns } from "./appointment_calendar.vue?vue&type=template&id=1021a4a4&scoped=true"
import script from "./appointment_calendar.vue?vue&type=script&lang=js"
export * from "./appointment_calendar.vue?vue&type=script&lang=js"
import style0 from "./appointment_calendar.vue?vue&type=style&index=0&id=1021a4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021a4a4",
  null
  
)

export default component.exports